import React from "react"

import Card from "~components/shared/card"
import CalendarEmptyView from "~components/pages/listing/calendar-empty-view"

interface Props {
    readonly hasPackages?: boolean
}

export default function NoPackagesCard({ hasPackages }: Props) {
    if (hasPackages) {
        return null
    }

    return (
        <Card>
            <CalendarEmptyView />
        </Card>
    )
}
